import AWS from "aws-sdk";

// AWS Cognito Configuration
// export const cognitoConfig = {
//   region: "us-west-2",
//   userPoolId: "us-west-2_cIHambCWK",
//   clientId: "2enh0qi3utq93k3i8rt3egh9pp",
//   identityPoolId: "YOUR_IDENTITY_POOL_ID",
// };

export const cognitoConfig = {
  region: "us-east-2",
  userPoolId: "us-east-2_gV1a5rD9Q",
  clientId: "6mudkj0ftuk2qq6hgc8v856jfr",
};

const useAuth = process.env.REACT_APP_USE_AUTH === "true"; // Check if auth is enabled

// AWS API Gateway URL
export const apiConfig = {
  baseUrl: useAuth
    // ? "api/" // Production API with authentication
    ? "https://api.lilbitofhope.com/v2/" // Production API with authentication
    : "http://localhost:4000", // Local API without authentication
};

// Configure AWS globally
AWS.config.update({
  region: cognitoConfig.region,
});
